export default __webpack_public_path__ + "static/media/lieferheld_m2.d66fbbef.png";